module.exports = __webpack_public_path__ + "img/MagicCarpet.5e1330e8.gif";